// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SA6l","col":"styles_col__2sAJM"};